function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M595.417-62.283h-1.571v-1.05a1.191,1.191,0,0,0-1.191-1.191h0a1.191,1.191,0,0,0-1.191,1.191v1.05h-5.432v-1.05a1.191,1.191,0,0,0-1.191-1.191h0a1.191,1.191,0,0,0-1.191,1.191v1.05H582.08a2.226,2.226,0,0,0-2.223,2.223v13.337A2.226,2.226,0,0,0,582.08-44.5h13.337a2.226,2.226,0,0,0,2.223-2.223V-60.06A2.226,2.226,0,0,0,595.417-62.283Zm.741,15.56a.742.742,0,0,1-.741.741H582.08a.742.742,0,0,1-.741-.741V-57.114h14.819Z",
  transform: "translate(-579.857 64.524)"
});

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.783,
    height: 20.024,
    viewBox: "0 0 17.783 20.024",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.21d4d14b.svg";
export { ForwardRef as ReactComponent };